import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../utils/GeneralUtils';
import { STOREFRONT_LANG_KEY } from '../../consts';

export const useLanguageChange = (accountDefaultLanguage: string | undefined) => {
  const { i18n } = useTranslation();
  const i18nRef = useRef(i18n);
  i18nRef.current = i18n;

  const location = useLocation();
  const language = useLanguage();
  const languageRef = useRef(language);
  languageRef.current = language;

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const swapLanguage = async () => {
      if (accountDefaultLanguage) {
        const savedLang = localStorage.getItem(STOREFRONT_LANG_KEY);
        const targetLang = savedLang || accountDefaultLanguage;
        const queryParams = new URLSearchParams(location.search);
        if (targetLang !== languageRef.current && !queryParams.get('language')) {
          await i18nRef.current.changeLanguage(targetLang);
        }
        setIsLoading(false);
      }
    };
    void swapLanguage();
  }, [accountDefaultLanguage, location.search]);

  return { isLoading };
};
